import moment, { Duration } from 'moment';
import { ITimespan } from './timespan.interface';

export namespace TimespanHelper {
    const defaultTimespanFormat = 'HH:mm:ss';

    export function fromString(timespanString: string): ITimespan {
        const duration = moment.duration(timespanString);
        const timespan: ITimespan = {
            Hours: GetHours(duration),
            Minutes: duration.minutes(),
            Seconds: duration.seconds(),
        };

        return timespan;
    }

    export function toString(timespan: ITimespan, format: string = defaultTimespanFormat): string {
        const timespanString = `${timespan.Hours}:${timespan.Minutes}:${timespan.Seconds}`;
        const timespanMoment = moment(timespanString, defaultTimespanFormat);
        const formattedTimespan = timespanMoment.format(format);

        return formattedTimespan;
    }

    export function isGreater(first: string, second: string): boolean {
        const firstDuration = moment.duration(first);
        const secondDuration = moment.duration(second);

        return firstDuration > secondDuration;
    }

    function GetHours(duration: Duration) {
        // we need to use `asHours()` and not `hours()` since we can have timespans >= 1 day
        // e.g. 26 hours and 30 seconds
        //      days() = 1, hours() = 2, minutes() = 30
        //      asHours() = 26,5
        var hoursWithDecimals = duration.asHours();
        var hoursInteger = Math.floor(hoursWithDecimals);

        return hoursInteger;
    }

    export function getMinutes(timespanString: string) {
        const duration = moment.duration(timespanString);

        return duration.asMinutes();
    }

    export function getSeconds(timespanString: string) {
        const duration = moment.duration(timespanString);

        return duration.asSeconds();
    }

    export function getMilliSeconds(timespanString: string) {
        const duration = moment.duration(timespanString);

        return duration.asMilliseconds();
    }

    export function getTimespanStringFromMilliSeconds(milliseconds: number) {
        return moment.utc(milliseconds).format(defaultTimespanFormat);
    }
}
